import { useSelector } from 'react-redux'
import { FieldsIcon } from '@gocanvas/gcds/icons'
import { SettingsLabel } from 'apps/studio/components/shared/inputs/SettingsLabel'
import { ConvertToPrefilledTable } from 'apps/studio/components/modals/ConvertToPrefilledTable'
import { BackgroundColor as defaultBackgroundColorConfig } from 'apps/studio/components/settings/fields/Base/design'
import {
  activeTableSheetKeyFieldSelector,
  sheetsSelector,
} from 'apps/formsCreationKit/store/selectors/entities'
import { ensureUniqueDescription } from 'apps/builder/lib/utils'
import { lib } from '@gocanvas/client'
const { LABELS_ABOVE_STYLE, TABLE_STYLE, TABLE_PRE_POPULATED_STYLE } = lib

export const BackgroundColor = {
  ...defaultBackgroundColorConfig,
  updateType: 'pageStyles',
}

export const TableName = {
  label: 'Table Name',
  settingType: 'longTextInput',
  updateType: 'sheet',
  property: 'description',
  additionalClasses: 'textarea--constrained',
  validationFunction: (sheetId, updatedValue, state) => {
    const sheets = sheetsSelector(state) || []
    return ensureUniqueDescription(sheets, updatedValue, sheetId)
  },
}

const TableStyle = {
  label: 'Table Style',
  settingType: 'selectInput',
  updateType: 'sheet',
  property: 'style',
  additionalValueMatches: {
    [TABLE_PRE_POPULATED_STYLE]: TABLE_STYLE,
  },
  choices: [
    {
      value: TABLE_STYLE,
      label: 'Table',
    },
    { value: LABELS_ABOVE_STYLE, label: 'Labels Above' },
  ],
}

export const HideTableName = {
  label: 'Hide table title on PDF',
  settingType: 'toggleInput',
  updateType: 'sheet',
  property: 'show_sheet_name', // may need to be a new setting, but this works for now
  choices: [
    { value: true, label: 'Show', previousValue: false },
    { value: false, label: 'Hide', previousValue: true },
  ],
}

export const PreFill = {
  label: 'Prefilled',
  settingType: 'toggleInput',
  updateType: 'sheet',
  property: 'style',
  tooltipContent: `Turning on pre-fill automatically adds every item from the dropdown into the table as rows, so you just review and remove any that don't apply. Enabling this setting will change the key field in your table to a dropdown.`,
  choices: [
    {
      value: TABLE_PRE_POPULATED_STYLE,
      label: 'Prefill',
      previousValue: TABLE_STYLE,
    },
    {
      value: TABLE_STYLE,
      label: 'No Prefill',
      previousValue: TABLE_PRE_POPULATED_STYLE,
    },
  ],
  isDisabled: ({ style }) =>
    useSelector(activeTableSheetKeyFieldSelector)?.type !== 'Dropdown' ||
    style === LABELS_ABOVE_STYLE,
  DisabledModalAction: ConvertToPrefilledTable,
}

export const TableStandardSettings = [
  TableName,
  SettingsLabel('Design'),
  BackgroundColor,
  TableStyle,
  PreFill,
  HideTableName,
]

export const TABLE_SETTINGS_PANEL = 'Table Settings'

export const TableSettingsPanel = (settings = []) => ({
  label: TABLE_SETTINGS_PANEL,
  icon: FieldsIcon,
  settings,
})
